import React, { Fragment } from 'react';
import { ieCheck  } from '../../../helpers/utils';
import { CYOA_NETWORK_IDS } from '../../../config';

const ProductCard = (props) => {

  const imageObj = {
    imageQuality:60,
    mapImages:props.data.fields.map.fields.file.url,
    mapPeople:props.data.fields.people.fields.file.url,
    mapHighlights:props.data.fields.highlightImages[0].fields.file.url
  }

  let productCurrency = "";
  let productPrice = "";

  if(props.data.fields.productsTMS !== undefined){
    productCurrency = (props.data.fields.productsTMS.prices_from.adult === "0.00") ? "" : "from " + props.data.fields.currency_mask.charAt(0);
    productPrice = (props.data.fields.productsTMS.prices_from.adult  === "0.00") ? "" : props.data.fields.productsTMS.prices_from.adult;
  }


  const standardImg = () => {
      return (
        <Fragment>
        <img
          alt={props.data.fields.name}
          data-srcset={`https:${imageObj.mapHighlights}?w=698&q=${imageObj.imageQuality} 1x,
          https:${imageObj.mapHighlights}?w=898&q=${imageObj.imageQuality} 2x`}
          data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          className="lazyload original" />
          <img
            alt={props.data.fields.name}
            data-srcset={`https:${imageObj.mapImages}?w=698&q=${imageObj.imageQuality} 1x,
            https:${imageObj.mapImages}?w=898&q=${imageObj.imageQuality} 2x`}
            data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            className="lazyload hover-img" />
        </Fragment> 
      )
  }

  const ieImg = () => {
    return (
      <img alt="" src={`https:${imageObj.mapHighlights}?w=698&q=${imageObj.imageQuality}`} />
    )
  }


  if(props.data.fields.tourId === CYOA_NETWORK_IDS["europe"].id){
    return (
      <div className="columns small-12 medium-6 large-4">
        <a href={`https://www.busabout.com/planner`} className="search-product-card cyoa-product europe" onClick={ () => { document.dispatchEvent(new CustomEvent('trips_product_click', {detail:props.data.fields.name })); } }>
            <div className="row">
              <div className="columns small-12">
                <div className="search-product-card-img europe">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
                        <path fill="#FF6700" fillRule="evenodd" d="M0 24c0 13.2548 10.7452 24 24 24 13.2486-.015 23.985-10.7514 24-24C48 10.7452 37.2548 0 24 0S0 10.7452 0 24h2.5263c0-11.8596 9.614-21.4737 21.4737-21.4737C35.854 2.5397 45.4603 12.146 45.4737 24c0 11.8596-9.6141 21.4737-21.4737 21.4737S2.5263 35.8596 2.5263 24H0z"/>
                        <path fill="#FF6700" fillRule="evenodd" d="M28.5444 25.2632H24c-.6976 0-1.2632-.5656-1.2632-1.2632v-4.5447c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v3.2815h3.2812c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                        <path fill="#FF6700" fillRule="evenodd" d="M24 36.6316c-.6976 0-1.2632-.5656-1.2632-1.2632v-7.3066c0-.6976.5656-1.2631 1.2632-1.2631.6976 0 1.2632.5655 1.2632 1.2631v7.3066c0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                        <path fill="#FF6700" fillRule="evenodd" d="M24 16.6934c-.6976 0-1.2632-.5655-1.2632-1.2632v-2.7986c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v2.7983A1.2632 1.2632 0 0 1 24 16.6934z"/>
                        <path fill="#FF6700" fillRule="evenodd" d="M19.851 25.2632h-7.2194c-.6976 0-1.2632-.5656-1.2632-1.2632 0-.6976.5656-1.2632 1.2632-1.2632h7.2194c.6976 0 1.2631.5656 1.2631 1.2632 0 .6976-.5655 1.2632-1.2631 1.2632z"/>
                        <path fill="#FF6700" fillRule="evenodd" d="M35.3684 25.2632H32.693c-.6977 0-1.2632-.5656-1.2632-1.2632 0-.6976.5655-1.2632 1.2632-1.2632h2.6755c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                    </svg>
                </div>

                <div className="search-product-content europe">
                  <p className="title">Europe</p>
                  <p className="subtitle">Adventure planner</p>
                </div>
              </div>
          </div>
        </a>
       </div>
    )
  }
  else if(props.data.fields.tourId === CYOA_NETWORK_IDS["usa"].id){
    return (
      <div className="columns small-12 medium-6 large-4">
      <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_USA_PAGE}`} className="search-product-card cyoa-product usa" onClick={ () => { document.dispatchEvent(new CustomEvent('trips_product_click', {detail:props.data.fields.name })); } }>
          <div className="row">
              <div className="columns small-12">
                <div className="search-product-card-img usa">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
                        <path fill="#3ABCCB" fillRule="evenodd" d="M0 24c0 13.2548 10.7452 24 24 24 13.2486-.015 23.985-10.7514 24-24C48 10.7452 37.2548 0 24 0S0 10.7452 0 24h2.5263c0-11.8596 9.614-21.4737 21.4737-21.4737C35.854 2.5397 45.4603 12.146 45.4737 24c0 11.8596-9.6141 21.4737-21.4737 21.4737S2.5263 35.8596 2.5263 24H0z"/>
                        <path fill="#3ABCCB" fillRule="evenodd" d="M28.5444 25.2632H24c-.6976 0-1.2632-.5656-1.2632-1.2632v-4.5447c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v3.2815h3.2812c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                        <path fill="#3ABCCB" fillRule="evenodd" d="M24 36.6316c-.6976 0-1.2632-.5656-1.2632-1.2632v-7.3066c0-.6976.5656-1.2631 1.2632-1.2631.6976 0 1.2632.5655 1.2632 1.2631v7.3066c0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                        <path fill="#3ABCCB" fillRule="evenodd" d="M24 16.6934c-.6976 0-1.2632-.5655-1.2632-1.2632v-2.7986c0-.6976.5656-1.2632 1.2632-1.2632.6976 0 1.2632.5656 1.2632 1.2632v2.7983A1.2632 1.2632 0 0 1 24 16.6934z"/>
                        <path fill="#3ABCCB" fillRule="evenodd" d="M19.851 25.2632h-7.2194c-.6976 0-1.2632-.5656-1.2632-1.2632 0-.6976.5656-1.2632 1.2632-1.2632h7.2194c.6976 0 1.2631.5656 1.2631 1.2632 0 .6976-.5655 1.2632-1.2631 1.2632z"/>
                        <path fill="#3ABCCB" fillRule="evenodd" d="M35.3684 25.2632H32.693c-.6977 0-1.2632-.5656-1.2632-1.2632 0-.6976.5655-1.2632 1.2632-1.2632h2.6755c.6976 0 1.2632.5656 1.2632 1.2632 0 .6976-.5656 1.2632-1.2632 1.2632z"/>
                    </svg>
                </div>

                <div className="search-product-content usa">
                  <p className="title">Usa</p>
                  <p className="subtitle">Adventure planner</p>
                </div>
              </div>
          </div>
      </a>
     </div>
    )
  }
  else{
    return (
      <div className="columns small-12 medium-6 large-4">
        <a href={props.data.fields.webUrl} className="search-product-card" onClick={ () => { document.dispatchEvent(new CustomEvent('trips_product_click', {detail:props.data.fields.name })); } }>
            <div className="row">
              <div className="columns small-12">
                <div className="search-product-card-img">
                  { ieCheck() ? ieImg() : standardImg() }
                  <div style={{display:`${props.data.fields.tourId === undefined ? 'none' : 'block' }`}}>
                    <span className="search-product-day">
                      <span className="fa fa-sun-o"></span>{props.data.fields.duration}{' days'}
                    </span>
                    <span className="search-product-price" style={{display:productPrice === "" ? 'none': 'inline'}}>{productCurrency}{productPrice}</span>
                  </div>
                </div>
              </div>
              <div className="columns small-12">
                <div className="search-product-content">
                  <p className="title">{props.data.fields.name}</p>
                </div>
              </div>
          </div>
        </a>
      </div>
    )
  }
}

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/tripSearch/products/product-card.js